import { CountyCodeShape, OptionListOption } from '@gaiads/telia-react-component-library';

export const COUNTRY_CALLING_CODES: CountyCodeShape[] = [
  { value: 'NO', countryName: 'Norway', code: '47' },
  { value: 'FI', countryName: 'Finland', code: '358' },
  { value: 'SE', countryName: 'Sweden', code: '46' },
  { value: 'DE', countryName: 'Denmark', code: '45' },
  { value: 'UK', countryName: 'UnitedKingdom', code: '44' },
];

export const COUNTRY_OPTIONS: OptionListOption[] = [
  { value: '', label: '' },
  { value: 'NO', label: 'Norway' },
];

export const DEFAULT_PAGE_SIZE = 10;

export const IMPORT_USERS_FLOW_CONSTANTS = {
  uploadTemplate: 'upload-template',
  reviewAndSave: 'review-and-save',
  summary: 'summary',
};

export const VERIFY_EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;

export const VERIFY_POSTAL_CODE = /^\d{4,5}$/;

export const VERIFY_PASSCODE = /^\d{6}$/;

export type SupportedLanguage = 'en' | 'no';

export const API_ERROR_AUTH_FAILED = {
  statusCode: 401,
  errorMessage: 'authentication_failed',
};

export const DATE_FORMAT = 'dd.LL.yyyy';
export const DATE_AND_TIME_FORMAT = 'dd.LL.yyyy HH:mm';

export const EMAIL_TO = 'mailto:device-norway@telia.no';
export const EMAIL_TITLE = 'device-norway@telia.no';

export const PHONE_NUMBER_TO = 'tel:+4793434444';
export const PHONE_NUMBER_TITLE = '+47 934 34 444';

// Add feature flags here. The keys need to match with names used in backend
export interface FeatureFlags {
  FEATURE_FLAG_CIAM_MFA_ENABLED: boolean;
  FEATURE_FLAG_FILTER_ASSETS_WAITING_FOR_RETURN_ENABLED: boolean;
  FEATURE_FLAG_FRONTEND_FLOW_BUYOUT_WITH_PRICE_ENABLED: boolean;
  FEATURE_FLAG_MANAGED_RETURN_FI_ENABLED: boolean;
  FEATURE_FLAG_MANAGED_RETURN_NO_ENABLED: boolean;
  FEATURE_FLAG_MANAGED_RETURN_SE_ENABLED: boolean;
  FEATURE_FLAG_PIM_AND_USER_GROUP_ROLES_ENABLED: boolean;
  FEATURE_FLAG_PIM_AND_USER_ROLES_ENABLED: boolean;
  FEATURE_FLAG_PRESCHEDULED_ONBOARDING_ENABLED: boolean;
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_FI_ENABLED: boolean;
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_NO_ENABLED: boolean;
  FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_SE_ENABLED: boolean;
}
